import React, {useContext, useEffect} from "react";
import "components/Content/Toolbar/CSS Files/tooglebar.css"
import "components/Content/Toolbar/CSS Files/Toolbar.css"
import {CreationContext} from "../../../containers/Content/CreationSuite";
import {fabric} from "fabric"

import Star from "../../../site_media/images/star.png"
import Rectangle from "../../../site_media/images/Rectangle.png"
import Circle from "../../../site_media/images/Circle.png"
import Hexagon from "../../../site_media/images/hexagon.png"
import Triangle from "../../../site_media/images/Triangle.png"
import Line from "../../../site_media/images/line_shape.png"




function regularPolygonPoints(sideCount,radius){
    let sweep=Math.PI*2/sideCount;
    let cx=radius;
    let cy=radius;
    let points=[];
    for(let i=0;i<sideCount;i++){
        let x=cx+radius*Math.cos(i*sweep);
        let y=cy+radius*Math.sin(i*sweep);
        points.push({x:x,y:y});
    }
    return(points);
}

function starPolygonPoints(spikeCount, outerRadius, innerRadius) {
  let rot = Math.PI / 2 * 3;
  let cx = outerRadius;
  let cy = outerRadius;
  let sweep = Math.PI / spikeCount;
  let points = [];
  let angle = 0;

  for (let i = 0; i < spikeCount; i++) {
    let x = cx + Math.cos(angle) * outerRadius;
    let y = cy + Math.sin(angle) * outerRadius;
    points.push({x: x, y: y});
    angle += sweep;

    x = cx + Math.cos(angle) * innerRadius;
    y = cy + Math.sin(angle) * innerRadius;
    points.push({x: x, y: y});
    angle += sweep
  }
  return (points);
}

export function ShapeLoader() {
    const {value} = useContext(CreationContext);
    const [creationCanvas, setCreationCanvas]= value;

    const addRectangleToCanvas = () => {
        let rectangle = new fabric.Rect({
            left: 50,
            top: 50,
            fill: '#1a3867',
            width: 400,
            height: 250,
            hasBorders: false
        });
        creationCanvas.add(rectangle)
    }

    const addCircleToCanvas = () => {
        let circle = new fabric.Circle({
            radius: 150,
            fill: '#1a3867',
            left: 100,
            top: 100,
            hasBorders: false
        });
        creationCanvas.add(circle);
    }

    const addLineToCanvas = () => {
        let line = new fabric.Line([50,100,200,200], {
            stroke: '#1a3867',
            left: 100,
            top: 100,
            hasBorders: false
        });
        creationCanvas.add(line);
    }

    const addTriangleToCanvas = () => {

        let points=regularPolygonPoints(3,150);

        let triangle= new fabric.Polygon(points, {
            stroke: '#1a3867',
            fill: '#1a3867',
            left: 10,
            top: 10,
            strokeWidth: 2,
            strokeLineJoin: 'bevil',
            hasBorders: false
        }, false);

        creationCanvas.add(triangle);
    }

    const addHexagonToCanvas = () => {

        let points=regularPolygonPoints(6,150);

        let hexagon= new fabric.Polygon(points, {
            stroke: '#1a3867',
            fill: '#1a3867',
            left: 10,
            top: 10,
            strokeWidth: 2,
            strokeLineJoin: 'bevil',
            hasBorders: false
        }, false);

        creationCanvas.add(hexagon);
    }

    const addStarToCanvas = () => {
        let points=starPolygonPoints(5,150,75);
        let star = new fabric.Polygon(points, {
            stroke: '#1a3867',
            fill: '#1a3867',
            left: 100,
            top: 10,
            strokeWidth: 2,
            strokeLineJoin: 'bevil',
            hasBorders: false
        }, false);
        creationCanvas.add(star);
    }

    useEffect(() => {
        creationCanvas.renderAll();
    })


    return(
        <div className = "shape-buttons">
            {/*Rectangle*/}
            <button id ="rectangle-shape"
                    onClick={addRectangleToCanvas}>
                <img src = {Rectangle}/>
            </button>

            {/*Circle*/}
            <button id ="circle-shape"
                     onClick={addCircleToCanvas}>
                <img src = {Circle}/>
            </button>

            {/*Triangle*/}
            <button id ="triangle-shape"
                     onClick={addTriangleToCanvas}>
                <img src = {Triangle}/>
            </button>

            {/*Hexagon*/}
            <button id ="hexagon-shape"
                     onClick={addHexagonToCanvas}>
                <img src = {Hexagon}/>
            </button>

            {/*Star*/}
            <button id ="star-shape"
                     onClick={addStarToCanvas}>
                <img src = {Star}/>
            </button>

            {/*Line*/}
            <button id ="line-shape"
                     onClick={addLineToCanvas}>
                <img src = {Line}/>
            </button>

        </div>

    )
}

class Shapes extends React.Component {

    render() {
        return (
            <div className="sidebar">
                <div className = "shape-selection">
                    <ShapeLoader/>
                </div>
            </div>
        );

    }
}

export default Shapes;